import classNames from "classnames/bind";
import styles from './InfoDetail.module.css';
import InfoUserItem from "../../../InfoUser/ShowInfoUser/InfoUserItem";
import { Col, DateTimePicker, Row, SelectBox, SelectBoxItem, Toast } from "../../../../components";
import { useEffect, useState, useTransition } from "react";
import { formatDB, formatDDMMYY, formatDateToTime } from "../../../../utils";
import PropTypes, { number } from 'prop-types';
import useFetchData from "../../../../hooks/useFetchData";
import axiosClient from "../../../../services/axiosClient";
import ChangePassForAdmin from "../ChangePassForAdmin/ChangePassForAdmin";

const cx = classNames.bind(styles)
function SideBarInfo({ data, getData, changed }) {
    const [companies, setCompanies] = useState([])
    const [name, setName] = useState('')
    const [birthDay, setBirthDay] = useState('')
    const [staffPosition, setStaffPosition] = useState('')
    const [company, setCompany] = useState('')
    const [type, setType] = useState('')
    const [userType, setUserType] = useState([])
    const [codeCompany, setCodeCompany] = useState('')
    const [staffCode, setStaffCode] = useState('')
    const [codeType, setCodeType] = useState('')
    const [listNation, setListNation] = useState([{ code: 'VNM', label: "Việt Nam" }])
    const [nationName, setNationName] = useState('')
    const [address, setAddress] = useState()
    const [phone, setPhone] = useState()
    const [email, setEmail] = useState()
    const staff = useFetchData('/staffPosition/get-list-staff-postion/')
    const [showChangePass, setShowChangePass] = useState(false)
    useEffect(() => {
        data?.forEach(element => {
            setName(element.NAME)
            setStaffPosition(element.STAFF_POSITTION_NAME)
            setCompany(element.COMPANY_NAME)
            setType(element.USERTYPE_NAME)
            setCodeType(element.USERTYPE_CODE)
            setBirthDay(element.BIRTHDAY ? element.BIRTHDAY : element.DATE_JOINED)
            setNationName(element.NATION_NAME)
            setAddress(element.ADDRESS_DETAIL)
            setPhone(element.PHONE)
            setEmail(element.EMAIL)
        });
    }, [data])
    useEffect(() => {
        const getCompanies = async () => {
            try {
                const res = await axiosClient.get('/company/get-list-company/')
                setCompanies(res?.data)
                res.forEach((item) => {
                    if (item.NAME === company) {
                        setCodeCompany(item.CODE)
                    }
                })
                return res
            } catch (error) {
                Toast.open('Không thẻ lấy danh sách công ty', 'danger')
            }
        }
        getCompanies()
    }, [company])

    useEffect(() => {
        const getCode = async () => {
            const res = await axiosClient.get(`userType/get-list-userType-for-add-user/?company_code=${codeCompany}`)
            setUserType(res)
            return res
        }
        getCode()
    }, [codeCompany])

    useEffect(() => {
        const nationCode = listNation.find(nation =>
            nationName && nation?.label?.trim().toLowerCase() === nationName?.trim().toLowerCase()) ?
            listNation.find(nation =>
                nation.label.trim().toLowerCase() === nationName.trim().toLowerCase()).code :
            ''
        getData({
            name,
            staffCode,
            codeCompany,
            codeType,
            birthDay,
            nationCode,
            address,
            phone,
            email
        })
        // eslint-disable-next-line
    }, [name,
        staffCode,
        codeCompany,
        codeType,
        nationName,
        birthDay,
        address,
        phone,
        email])

    const onChangeType = (data) => {
        setCodeType(data)
        if (userType.length > 0) {
            userType.forEach((item) => {
                if (data === item.CODE) {
                    setType(item.SUBJECT_NAME)
                }
            })
        }
        changed(true)
    }
    const handleChangeName = (data) => {
        setName(data)
        changed(true)
    }
    const handleChangeStaff = (data) => {
        setStaffCode(data)
        changed(true)
    }
    const handleChangeBirthDay = (data) => {
        setBirthDay(data.target.value);
        changed(true)
    }
    const handleChangeNation = (data) => {
        const nameNation = listNation.find(item => item.code === data) ? listNation.find(item => item.code === data).label : '';
        setNationName(nameNation)
        changed(true)
    }
    const handleChangeAddress = (data) => {
        setAddress(data)
        changed(true)
    }
    const handleChangePhone = (data) => {
        setPhone(data)
        changed(true)
    }
    const handleChangeEmail = (data) => {
        setEmail(data)
        changed(true)
    }
    const handleChangePass = () => {
        // // console.log('run');
        setShowChangePass(!showChangePass)
    }
    return (
        <div className={cx('info')}>
            <div className={cx('title')}>Thông tin chung</div>
            {data?.map((item, index) => {
                return (
                    <div className={cx('info-container')} key={index}>
                        <Row gap={[0, 30]} >
                            <Col span={4}>
                                <InfoUserItem type={'text'} label={'Tên người dùng'} value={name} onChange={handleChangeName} size={'small'} />
                                <InfoUserItem label={'Tên đăng nhập'} disabled value={item.USERNAME} size={'small'} />
                                <DateTimePicker onChange={handleChangeBirthDay} value={birthDay} title={"Ngày sinh"} styles={{ paddingTop: 0 }} typeDate={'date'} />
                                <SelectBox
                                    type="small"
                                    title={'Quốc tịch'}
                                    className={cx('select-box')}
                                    values={nationName ? nationName : 'Chưa cập nhật'}
                                    onChange={handleChangeNation}>
                                    {listNation.map((nation, index) => {
                                        return (
                                            <SelectBoxItem key={`${index}_${nation.code}`} label={nation.label} value={nation.code} />
                                        )
                                    })}
                                </SelectBox>
                                <InfoUserItem label={'Địa chỉ'} value={address} placeholder={address ? '' : 'Chưa cập nhật'} size={'small'} onChange={handleChangeAddress} />
                            </Col>
                            <Col span={4}>
                                <InfoUserItem label={'Số điện thoại'} value={phone} placeholder={phone ? '' : 'Chưa cập nhật'} size={'small'} onChange={handleChangePhone} />
                                <InfoUserItem label={'Email'} value={email} placeholder={email ? '' : 'Chưa cập nhật'} size={'small'} onChange={handleChangeEmail} />
                                <InfoUserItem label={'Đơn vị'} disabled value={item.COMPANY_NAME ? item.COMPANY_NAME : 'Chưa cập nhật'} size={'small'} />
                                <SelectBox
                                    onChange={handleChangeStaff}
                                    values={staffPosition ? staffPosition : 'Chưa cập nhật'}
                                    style={{ marginTop: -2, padding: '0px 0px 8px 0px' }}
                                    type="small"
                                    title={'Chức vụ'}
                                >
                                    {staff?.data.map((item) => {
                                        return (
                                            <SelectBoxItem key={item.CODE} label={item.SUBJECT_NAME} value={item.CODE} />
                                        )
                                    })}
                                </SelectBox>
                                <InfoUserItem label={'Trạng thái'} disabled value={item.STATUS ? item.STATUS : 'Không hoạt động'} size={'small'} />
                            </Col>
                            <Col span={4}>
                                <SelectBox
                                    onChange={onChangeType}
                                    values={type && type.trim().length > 0 ? type : 'Chưa cập nhật'}
                                    style={{ padding: '0px 0px 8px 0px' }}
                                    type="small"
                                    title={"Phân quyền"}
                                >
                                    {userType?.map((item, index) => {
                                        return (
                                            <SelectBoxItem label={item.SUBJECT_NAME} value={item.CODE} key={index} />
                                        )
                                    })}
                                </SelectBox>
                                <InfoUserItem label={'Bắt đầu hoạt động'} time disabled value={formatDateToTime(item.DATE_JOINED)} size={'small'} />
                                <InfoUserItem label={'Sửa lần cuối'} time disabled value={formatDateToTime(item.EDIT_TIME)} size={'small'} />
                                <button className={cx('link-change-pass')} onClick={handleChangePass}>
                                    Thay đổi mật khẩu người dùng
                                </button>
                                <ChangePassForAdmin open={showChangePass} infoUser={data} onClose={handleChangePass} />
                            </Col>
                        </Row>
                    </div>
                )
            })}
        </div >
    )
}
SideBarInfo.propTypes = {
    data: PropTypes.array.isRequired,
    getData: PropTypes.func,
}
export default SideBarInfo;